/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icn_replace': {
    width: 42.667,
    height: 42.667,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M11.5 5c-5.9 2.4-9 10.3-6.2 15.9.9 1.7 1.1 3.1.6 3.1-.5 0-.9.4-.9 1 0 .5 1.4 1 3 1 2.7 0 3-.3 3-3 0-3.1-2-4.3-2-1.3-.1 2.7-2.9-2.6-3-5.5 0-4 2.8-8 6.5-9.3 1.9-.7 3.5-1.7 3.5-2.1 0-1-1.9-.9-4.5.2zM18 5c0 .5.5 1 1.1 1 .5 0 .7-.5.4-1-.3-.6-.8-1-1.1-1-.2 0-.4.4-.4 1zM21 9c0 3.1 2 4.3 2 1.2.1-2.6 2.9 2.7 3 5.6 0 4-2.8 8-6.5 9.3-4.1 1.5-4.7 3.4-.7 2.4 6.8-1.6 11-10.2 7.9-16.4-.9-1.7-1.1-3.1-.6-3.1.5 0 .9-.5.9-1 0-.6-1.3-1-3-1-2.7 0-3 .3-3 3zM12.5 27c.3.5.8 1 1.1 1 .2 0 .4-.5.4-1 0-.6-.5-1-1.1-1-.5 0-.7.4-.4 1z"/>'
  }
})
